export default __webpack_public_path__ + "images/7e13dac2cb552004de7f4d8d5f307489-cycling.jpg";